export default __webpack_public_path__ + "static/media/November2013.51be3fc5.png";